const QUERY_KEYS = {
  REPORT_CONFIG: "report-config",
  REPORT_DATA: "report-data"
};
export {
  QUERY_KEYS
};
